export const endPoints = {
  FLAT_FILTER: '/v1/flat/filter',
  FILTER_PARAMS: '/v1/flat/filter/params',
  HOUSE_EXTRA: '/v1/house/extra'
};
